export default "__VITE_ASSET__CgO53pc___"